<template>
    <ul v-if="hasMessages" class="te-cart-conditional-messages">
        <li v-for="orderMessage in orderMessages" :key="orderMessage.id" class="te-cart-conditional-message">
<!--            <span>{{orderMessage.message}}</span>-->
            <span v-html="orderMessage.message"></span>
        </li>
    </ul>
</template>

<script>
    import { mapGetters } from "vuex";

    export default {
        name: "OrderMessages",

        computed: {
            ...mapGetters({
                orderMessages: 'orderMessages',
            }),

            hasMessages: function () {
                return this.orderMessages && this.orderMessages.length > 0;
            },
        },

        methods: {

            // setOptInOn(optInOn) {
            //     this.optInOn = optInOn || [];
            // },

        },
    }
</script>

<style scoped>

</style>
